import { FlightPathCanvas } from "heat-next";

import { useSessionDetailsContext } from "@/context/session-details/session-details";

import { ComponentWrapper } from "@/pages/shared/shared.styles";

import ContentLoader from "@/components/content-loader/content-loader";
import EmptyState from "@/components/empty-state/empty-state";
import { EmptyStateType } from "@/components/empty-state/empty-state.types";

interface FlightPathXCognitiveLoadProps {
    isInsideModal?: boolean;
    subDimensionsData?: any;
}

const FlightPath = ({ isInsideModal, subDimensionsData }: FlightPathXCognitiveLoadProps) => {
    const { flightCircuitData, isFetchingFlightCircuit, isErrorFlightCircuit } =
        useSessionDetailsContext();

    //FlightPath
    const flightCircuit = isInsideModal
        ? subDimensionsData?.flat().filter((item: any) => item?.chartType === "FlightPath")
        : flightCircuitData;

    //Prepare data for FlightPathXCognitiveLoad component per circuit
    const flightPathData = flightCircuit?.map((circuit: any) => {
        return {
            title: circuit.title || "Flight Path",
            flightPathData: circuit,
        };
    });

    const isFlightCircuitDataEmptyState =
        !isErrorFlightCircuit && (!flightPathData || flightPathData?.pathData?.length === 0);

    const isEmptyState = () => {
        if (isInsideModal) {
            return subDimensionsData?.every((v: any) => v === undefined);
        } else if (isFlightCircuitDataEmptyState) {
            return true;
        }
    };

    if (isFetchingFlightCircuit) {
        return <ContentLoader height="28.875rem" />;
    }

    if (!isInsideModal && isErrorFlightCircuit && !isFetchingFlightCircuit) {
        return (
            <ComponentWrapper>
                <EmptyState
                    title="error-state:title"
                    emptyStateType={EmptyStateType.Error}
                    minHeight="18.1875rem"
                />
            </ComponentWrapper>
        );
    }

    if (isEmptyState()) {
        return (
            <ComponentWrapper>
                <EmptyState
                    title="session-detail:no-flight-path-data"
                    emptyStateType={EmptyStateType.Charts}
                    minHeight="25.875rem"
                />
            </ComponentWrapper>
        );
    }

    if (isFetchingFlightCircuit) {
        return <ContentLoader height={"26.4375rem"} />;
    }

    return (
        <FlightPathCanvas
            dualPlaybackProps={{
                rowGap: "0.5rem",
                leftPercent: 100,
                hasRightComponent: false,
            }}
            isInsideModal={isInsideModal}
            data={flightPathData}
        />
    );
};

export default FlightPath;
